import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=6b5f5d64&scoped=true"
import script from "./ShoppingList.vue?vue&type=script&lang=ts"
export * from "./ShoppingList.vue?vue&type=script&lang=ts"
import style0 from "./ShoppingList.vue?vue&type=style&index=0&id=6b5f5d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f5d64",
  null
  
)

export default component.exports